import { ApplicationClientInputMetadata } from '@/api/models/application';
import { FieldData } from '@/components/registration/models/field';

export const enum AGREEMENT_CONTRACT_STATUS {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  PREPARED = 'prepared',
  SIGNED = 'signed',
  APPROVED = 'approved',
  REGISTERED = 'registered',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  ISSUED = 'issued',
  REPAID = 'repaid',
  TERMINATED = 'terminated',
  ABORTED = 'aborted'
}

export const enum AGREEMENT_PROCESSING_STATUS {
  PENDING = 'pending',
  ACTIVE = 'active',
  CLOSED = 'closed'
}

export const ONLINE_SIGNING_TYPE = 'online';

export interface Agreement {
  id: string;
  loanId: string;
  number: string;
  contractStatus: AGREEMENT_CONTRACT_STATUS;
  processingStatus: AGREEMENT_PROCESSING_STATUS;
  calculatorInput: ApplicationClientInputMetadata;
  applicationId: string;
  productId: string;
  companyId: string;
  clientId: string;
  scheduleId: string;
  agreementId: string;
  features: string[];
  signingMethod?: AgreementSigningMethod;
  documents: AgreementDocument[];
}

export interface AgreementDocument {
  documentId: string;
  type: string;
  details: AgreementDocumentSignDetails;
}

export interface AgreementDocumentSignDetails {
  signed: boolean;
  details?: SignOnlineSignDetails;
}

export interface SignOnlineSignDetails {
  signOnlineId: string;
  signOnlineLink: string;
}

export interface AgreementSigningMethod {
  type: string;
  data?: FieldData;
}

export interface AgreementRequestList {
  productId?: string;
  applicationId?: string;
  loanId?: string;
  companyId?: string;
  scheduleId?: string;
  headId?: string;
  paymentId?: string;
  paymentOrderId?: string;
  number?: string;
  contractStatus?: AGREEMENT_CONTRACT_STATUS;
  processingStatus?: AGREEMENT_PROCESSING_STATUS;
}
